import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoadingService } from './core/services/loading-service';
import { MatProgressBarModule } from '@angular/material/progress-bar';
@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    MatProgressBarModule
  ],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App {
  protected readonly title = signal('growfiWeb');
  constructor(public loadingService: LoadingService,
  ) {

  }
}
